module.exports = __webpack_public_path__ + "img/wechat.1f6b7d74.svg";